import { themeSelector } from '@/redux/store/slices/theme/themeSlice'
import { MAP_THEMES } from '@/theme'
import { useAppSelector } from '@redux/hooks/useAppState'

export const useMapStyle = () => {
	const theme = useAppSelector(themeSelector)
	return MAP_THEMES[theme as keyof typeof MAP_THEMES]
}
